module.exports = __webpack_public_path__ + "img/hero.5d5c3924.webp";